"use client";

import { ReactNode, useState } from "react";
import PAText from "../typography/PAText/PAText";
import styles from "./style.module.scss";

interface IProps{
  titles: string[];
  children: ReactNode[];
  selected?: number;
  component?: string;
}

function PATabs(props: IProps) {
  const {
    titles, component, children, selected,
  } = props;
  const [selectedTab, setSelectedTab] = useState(selected || 0);

  return (
    <>
      <ul className={styles.tab_titles}>
        {children.map((elem, index) => (
          <li
            role="presentation"
            key={titles[index]}
            className={`${styles.tab_title} ${selectedTab === index ? styles.tab_title_active : ""}`}
            onClick={() => setSelectedTab(index)}
          >

            <PAText
              component={component}
            >
              {titles[index]}
            </PAText>
          </li>
        ))}
      </ul>
      {children.map((child, index) => (
        <div className={index === selectedTab ? styles.tab : styles.hidden_tab} key={index}>
          {child}
        </div>
      ))}
    </>
  );
}

export default PATabs;
